import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setOpen } from "../../../Redux/ModalReducer";
import { Button } from "@mui/material";
import CustomModal from './index'

const Data = ({data}) => {
  const dispatch = useDispatch();

  const [showDescriptionModal, setShowDescriptionModal] = useState(false);

  const handleShowDescriptionModal = () => {
    setShowDescriptionModal(true);
    dispatch(setOpen(true));
  };
  return (
    <>
      <Button onClick={handleShowDescriptionModal}>View</Button>
      <CustomModal
        show={showDescriptionModal}
        setShow={setShowDescriptionModal}
        data={data}
      />
    </>
  );
};

export default Data;
